module.exports = __webpack_public_path__ + "static/builders-risk-insurance-bac85971a650cc0d3b641514a65d8a60.svg";